import { render } from "./Home.vue?vue&type=template&id=37e2e413&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=37e2e413&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wei-d\\Documents\\TNTAIAGENT\\TNTAIAgent\\tntaiagent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e2e413"]])

export default __exports__